"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichEditLayoutApi = void 0;
var client_command_1 = require("../base/commands/client-command");
var RichEditLayoutApi = (function () {
    function RichEditLayoutApi(core) {
        this._core = core;
    }
    Object.defineProperty(RichEditLayoutApi.prototype, "showHiddenSymbols", {
        get: function () {
            return this._core.innerClientProperties.showHiddenSymbols;
        },
        set: function (value) {
            var command = this._core.commandManager.getCommand(client_command_1.RichEditClientCommand.ToggleShowWhitespace);
            command.execute(true, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichEditLayoutApi.prototype, "showTableGridLines", {
        get: function () {
            return this._core.innerClientProperties.showTableGridLines;
        },
        set: function (value) {
            var command = this._core.commandManager.getCommand(client_command_1.RichEditClientCommand.ToggleShowTableGridLines);
            command.execute(true, value);
        },
        enumerable: false,
        configurable: true
    });
    return RichEditLayoutApi;
}());
exports.RichEditLayoutApi = RichEditLayoutApi;
